var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "topBg" },
    [
      _c("div", { staticClass: "topBtn" }, [
        _vm.companyId != "10015"
          ? _c("div", { staticClass: "signOut", on: { click: _vm.signOut } })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "news",
            on: {
              click: function($event) {
                _vm.to("news")
              }
            }
          },
          [
            _vm.count > 0
              ? _c("div", { staticClass: "num" }, [_vm._v(_vm._s(_vm.count))])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "userBox" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "userName" }, [
              _vm._v(_vm._s(_vm.nickName))
            ]),
            _vm._v(" "),
            _vm.companyId != "10015"
              ? _c("div", { staticClass: "phoneBox" }, [
                  _c("div", { staticClass: "studentNo" }, [
                    _vm._v(_vm._s(_vm.userPhone))
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "span",
                    on: {
                      click: function($event) {
                        _vm.to("changePhone")
                      }
                    }
                  })
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tabList" }, [
        _c(
          "div",
          {
            staticClass: "tabItem",
            on: {
              click: function($event) {
                _vm.to("consult")
              }
            }
          },
          [_c("div", { staticClass: "itemIcon m1" }), _vm._v(" "), _vm._m(1)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabItem",
            on: {
              click: function($event) {
                _vm.to("myTest")
              }
            }
          },
          [_c("div", { staticClass: "itemIcon m2" }), _vm._v(" "), _vm._m(2)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabItem",
            on: {
              click: function($event) {
                _vm.to("myCourse")
              }
            }
          },
          [_c("div", { staticClass: "itemIcon m3" }), _vm._v(" "), _vm._m(3)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabItem",
            on: {
              click: function($event) {
                _vm.to("myEBook")
              }
            }
          },
          [_c("div", { staticClass: "itemIcon m6" }), _vm._v(" "), _vm._m(4)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabItem",
            on: {
              click: function($event) {
                _vm.to("myCollection")
              }
            }
          },
          [_c("div", { staticClass: "itemIcon m4" }), _vm._v(" "), _vm._m(5)]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tabItem",
            on: {
              click: function($event) {
                _vm.to("feedback")
              }
            }
          },
          [_c("div", { staticClass: "itemIcon m5" }), _vm._v(" "), _vm._m(6)]
        )
      ]),
      _vm._v(" "),
      _c("footerBox", { attrs: { active: "4" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "userImgBox" }, [
      _c("div", { staticClass: "userImg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabWordBox" }, [
      _c("div", { staticClass: "tabName" }, [
        _vm._v("\n                        咨询\n                    ")
      ]),
      _vm._v("\n                    疏导心结自我和解\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabWordBox" }, [
      _c("div", { staticClass: "tabName" }, [
        _vm._v("\n                        测评\n                    ")
      ]),
      _vm._v("\n                    认识内心的自我\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabWordBox" }, [
      _c("div", { staticClass: "tabName" }, [
        _vm._v("\n                        课程\n                    ")
      ]),
      _vm._v("\n                    查看近期的课程\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabWordBox" }, [
      _c("div", { staticClass: "tabName" }, [
        _vm._v("\n                        电子书\n                    ")
      ]),
      _vm._v("\n                    查看近期的电子书\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabWordBox" }, [
      _c("div", { staticClass: "tabName" }, [
        _vm._v("\n                        收藏\n                    ")
      ]),
      _vm._v("\n                    文章视频课程测评\n                ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabWordBox" }, [
      _c("div", { staticClass: "tabName" }, [
        _vm._v("\n                        反馈\n                    ")
      ]),
      _vm._v("\n                    提出建议我们修改\n                ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49e49dbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49e49dbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/my.vue
// module id = null
// module chunks = 